<template>
<span class="h-full w-full">
    <el-checkbox v-if="modifiable" v-model="editing.value"  @change="checkChange" :true-label="trueFlag" :false-label="falseFlag"></el-checkbox>
    <el-checkbox v-else disabled v-model="checked"  @change="checkChange" :true-label="trueFlag" :false-label="falseFlag"></el-checkbox>
</span>
</template>

<script>
import isNil from 'lodash/isNil';
import Editingf from '@/mixins/editingForm';
export default {
  name: 'w-check-form',
  props: ['modifiable', 'target', 'property', 'tfType'], //tfType = Boolean or Number
  mixins: [Editingf],
  watch: {
    modifiable: {
      immediate: true,
      deep: true,
      handler: function(val, oldVal) {
        if (val) {
          this.startEdit(this.target, this.property);
        } else if(!isNil(oldVal)){
          // 수정 진행 -> 종료 일경우에만
          this.endEdit(this.editing.value);
        }
      }
    },
  },
  computed: {
    checked() {
      return this.target[this.property];
    },
    trueFlag() {
      return this.tfType ? (this.tfType==="Number" ? "1":"true") : "true";
    },
    falseFlag() {
        return this.tfType ? (this.tfType==="Number" ? "0":"false") : "false";
    }
  },
  methods: {
    checkChange(value) {
      this.updateEdit(value);
    }
  },
  data() {
    return {};
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/formeditor/CheckFormEditor.vue